import React from 'react';
import { IconUIComponentProps, useIconStyle } from './Icon';

export default function ({
  color,
  size,
  style,
  className,
  noFill,
}: IconUIComponentProps) {
  const styles = useIconStyle({ noFill });
  return (
    <svg
      className={[styles.icon, className].join(' ').trim()}
      color={color}
      fontSize={size}
      style={style}
      viewBox="0 0 24 22"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.25 6.5015C8.23394 6.5015 8.21799 6.501 8.20218 6.5H7.5V20H16.5V6.5H8.29782C8.28201 6.501 8.26606 6.5015 8.25 6.5015ZM18 6.5V20H21.9174C22.2383 20 22.4994 19.7387 22.4994 19.4165V7.0835C22.4994 6.76132 22.2383 6.5 21.9174 6.5H18ZM17.25 21.5H21.9175C23.0671 21.5 23.9995 20.5669 23.9995 19.4165V7.0835C23.9995 5.93315 23.0671 5 21.9175 5H17.25H16.5V4.25C16.5 2.17979 14.8202 0.5 12.75 0.5H11.25C9.17979 0.5 7.5 2.17979 7.5 4.25V5H6.75H2.08301C0.933411 5 -0.000488281 5.93317 -0.000488281 7.0835V19.4165C-0.000488281 20.5668 0.933411 21.5 2.08301 21.5H6.75H17.25ZM6 20V6.5H2.08292C1.76149 6.5 1.49942 6.76186 1.49942 7.0835V19.4165C1.49942 19.7381 1.76149 20 2.08292 20H6ZM9 5V4.25C9 3.00821 10.0082 2 11.25 2H12.75C13.9918 2 15 3.00821 15 4.25V5H9Z"
      />
    </svg>
  );
}